import {
  parseVisualGameAdminAnalyticsOverviewResponse,
  parseVisualGameAdminAnalyticsDrilldownResponse,
  parseVisualGameAdminPlayerInteractionsResponse,
  parseVisualGameAdminContentAnalyticsResponse,
  parseVisualGameAdminGa4BehaviorResponse,
} from '@drama/contracts'
import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureAnalyticsHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/admin/visual-game/analytics' })
}

export async function getAnalyticsOverview(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  const response = await http.get('/overview', { query, routeId: 'visualGame.analytics.overview' })
  return parseVisualGameAdminAnalyticsOverviewResponse(response)
}

export async function getContentAnalytics(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  const response = await http.get('/content', { query, routeId: 'visualGame.analytics.content' })
  return parseVisualGameAdminContentAnalyticsResponse(response)
}

export async function getAnalyticsDrilldown(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  const response = await http.get('/drilldown', { query, routeId: 'visualGame.analytics.drilldown' })
  return parseVisualGameAdminAnalyticsDrilldownResponse(response)
}

export async function getPlayerInteractions(userId, query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  const response = await http.get(`/players/${encodeURIComponent(userId)}/interactions`, {
    query,
    routeId: 'visualGame.analytics.playerInteractions',
  })
  return parseVisualGameAdminPlayerInteractionsResponse(response)
}

export async function getGa4Behavior(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  const response = await http.get('/ga4/behavior', { query, routeId: 'visualGame.analytics.ga4Behavior' })
  return parseVisualGameAdminGa4BehaviorResponse(response)
}

export async function getConversionFunnel(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  return http.get('/conversion-funnel', { query, routeId: 'visualGame.analytics.conversionFunnel' })
}

export async function getConversionFunnelVisitors(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  return http.get('/conversion-funnel/visitors', { query, routeId: 'visualGame.analytics.conversionFunnelVisitors' })
}

export async function getConversionFunnelTrafficVideos(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  return http.get('/conversion-funnel/traffic-videos', { query, routeId: 'visualGame.analytics.conversionFunnelTrafficVideos' })
}

export async function getConversionFunnelAuthActivity(query) {
  if (http === null) throw new Error('configureAnalyticsHttp must be called before analytics API use')
  return http.get('/conversion-funnel/auth-activity', { query, routeId: 'visualGame.analytics.conversionFunnelAuthActivity' })
}
